import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=5d15aabd&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=5d15aabd&prod&lang=scss&scoped=true"
import style1 from "./Notice.vue?vue&type=style&index=1&id=5d15aabd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d15aabd",
  null
  
)

export default component.exports